import localConfig from './local'
import testConfig from './test'
import prDevConfig from './prDev'
import prStageConfig from './prStage'
import developmentConfig from './development'
import stagingConfig from './staging'
import previewConfig from './preview'
import productionConfig from './production'

const getEnvConfig = (env) => {
  switch (env) {
    case 'local': {
      return localConfig
    }
    case 'prDev': {
      return prDevConfig
    }
    case 'prStage': {
      return prStageConfig
    }
    case 'development': {
      return developmentConfig
    }
    case 'test': {
      return testConfig
    }
    case 'staging': {
      return stagingConfig
    }
    case 'preview': {
      return previewConfig
    }
    default: {
      return productionConfig
    }
  }
}

export default getEnvConfig(process.env.APP_ENV)
